/**
 * TVG-350: the internal login types an administrator can assign, with their
 * display names. Salesperson carries exactly the same permissions as Staff —
 * every gate that accepts `staff` also accepts `salesperson` — so it only
 * differs by name.
 */
export const ROLE_CHOICES: { value: string; label: string }[] = [
  { value: 'manager', label: 'Manager' },
  { value: 'staff', label: 'Staff' },
  { value: 'salesperson', label: 'Salesperson' },
  { value: 'admin', label: 'Admin' },
];

const ROLE_LABELS = new Map<string, string>([
  ...ROLE_CHOICES.map((choice) => [choice.value, choice.label] as [string, string]),
  ['customer', 'Customer'],
]);

export function roleLabel(role: string): string {
  return ROLE_LABELS.get(role) ?? role;
}

export function roleLabels(roles: string[] | undefined | null): string {
  return (roles ?? []).map(roleLabel).join(', ');
}
